var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"text txt-secondary"},[_c('td',{staticClass:"text-left"},[_vm._v("\n    "+_vm._s(_vm.computedTitle)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.item.costs))])])
}
var staticRenderFns = []

export { render, staticRenderFns }